import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert } from "../Alerts/actions";
import { fetchTaskFailure, fetchTaskSuccess } from "./actions";
import { FETCH_TASK } from "./constants";

export function* fetchTaskSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/enquiries-reminder?${query}`
    );
    yield put(fetchTaskSuccess(data));
    typeof onSuccess === "function" && onSuccess();
  } catch (e) {
    yield put(fetchTaskFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching task!"));
  }
}

export function* fetchTaskFlow() {
  yield takeEvery(FETCH_TASK, fetchTaskSaga);
}

export default function* TaskSaga() {
  yield all([fetchTaskFlow()]);
}
